export default "__VITE_PUBLIC_ASSET__b1ace564__"